import { Icon } from "@blueprintjs/core"
import { MouseEvent } from "react"
import { __ } from "src/libs/utilities"
import { CardFiled, CardsContent, } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import cardFieldsDefault from "src/modules/pe-landing-module/data/utils/cardFieldsDefault"

/* Protopia Ecosystem component */
export interface ISingleCardFieldProps {
   cf: CardFiled
   order: string[]
}
const SingleCardField = ({cf, order, ...props}: ISingleCardFieldProps): JSX.Element => {  
    const selectedCardField: CardFiled      = useLandingStore( (state:ILandingStore) => state.selectedCardField )
    const currentCardEdit: CardsContent     = useLandingStore( (state:ILandingStore) => state.currentCardEdit )
    const onDeleteCardField                 = useLandingStore( (state:ILandingStore) => state.onDeleteCardField )
    const onVisibleCardField                = useLandingStore( (state:ILandingStore) => state.onVisibleCardField )
    const onDownCardField                   = useLandingStore( (state:ILandingStore) => state.onDownCardField )

    const onSelect = ( evt: MouseEvent ) => {
        evt.stopPropagation()
        evt.preventDefault()
        useLandingStore.setState({ selectedCardField : cf })
    }
    const onVisible = (evt: MouseEvent) => {
        evt.stopPropagation()
        evt.preventDefault()
        onVisibleCardField( cf )
    }
    const onDelete = (evt: MouseEvent) => {
        evt.stopPropagation()
        evt.preventDefault()
        onDeleteCardField( cf )
    }  
    const onDown = (evt: MouseEvent) => {
        evt.stopPropagation()
        evt.preventDefault() 
        onDownCardField( cf )
    }
    const isVisibled = order.includes(cf.type)

    return <div className={`panel-list-button pl-0 ${ JSON.stringify( selectedCardField || "") === JSON.stringify( cf ) ? "active" : "" }`} onClick={onSelect}>
        <div className={`d-flex w-100 align-items-center pr-2 ${ isVisibled ? "" : "opacity_5" } `}>
            <img src={ cardFieldsDefault()[ cf.type ]?.icon } alt="" height={ 12 } className="invert-image mx-1" />
            <div className="micro letter-spacing-2 text-uppercase text-light">
                { __(cf.type) }
            </div>
            <div className="ml-auto" /> 
            
            <Icon icon={ isVisibled ? "eye-open" : "eye-off" } size={ 10 } color="#FFF" className="pointer hover mx-1 pe-surface2" onClick={onVisible} />  
            <Icon icon={ "trash" } size={ 10 } color="#FFF" className="pointer hover mx-1 pe-surface2" onClick={onDelete} />   
            {
                currentCardEdit.card_fields.findIndex( casrdField => cf.id === casrdField.id ) < currentCardEdit.card_fields.length - 1 
                    ?
                    <Icon icon={ "arrow-down" } size={ 10 } color="#FFF" className="pointer hover mx-1 pe-surface2" onClick={onDown} />  
                    : 
                    <Icon icon={ "blank" } size={ 10 } className="pointer hover mx-1 pe-surface2" />   
            }
            
        </div>
    </div> 
}
export default SingleCardField